<template>
  <div class="order-card">
    
    <div class="order-header">
      <div class="order-number" @click="getOneOrder()">
        <span class="number">{{ o.ordernumber }}</span>
        <span class="crm-number" v-if="o.crmnumber">{{ o.crmnumber }}</span>
      </div>
      <div class="order-and-full">
      <div class="order-status" :class="getStatusClass(o.status)">
        {{ orderInfoStatus[o.status] }}
      </div>
      <svg @click="getOneOrderItems()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
        <path d="M8 8L12 12M8 8V11M8 8H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M16 16L12 12M16 16V13M16 16H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      </div>
    </div>


    <div class="info-line" @click="getOneOrder()">
      <span class="info-label">Канал продаж:</span>
      <span class="info-value">{{ channelInfo[o.channel] }}</span>
    </div>


    <div class="info-line" @click="getOneOrder()" v-if="o.delivery.length > 0 && o.delivery[0].service">
      <span class="info-label">Тип доставки:</span>
      <span class="info-value">{{ deliveryName[o.delivery[0].service] }}</span>
    </div>
    <div class="info-line" @click="getOneOrder()" v-if="o.delivery.length > 0 && o.delivery[0].service">
      <span class="info-label">Оплата:</span>
      <span class="info-value" :class="{noOp:payMentsGood}">{{ payMentsGood ? 'Оплачен' : 'Не оплачен' }}</span>
    </div>


    <div class="order-stats" @click="getOneOrder()">
      <div class="stat-item">
        <span class="stat-label">Дата</span>
        <span class="stat-value">{{ goodData(o.createdAt, 'short') }}</span>
      </div>
      
      <div class="stat-item">
        <span class="stat-label">Товары</span>
        <span class="stat-value">{{ o.items.length }} шт</span>
      </div>
      
      <div class="stat-item">
        <span class="stat-label">Сумма</span>
        <span class="stat-value price">{{ viewPriceAll.toLocaleString('ru-RU') }} ₽</span>
      </div>
    </div>

 
    <div class="special-block" v-if="hasSpecialBadges" @click="getOneOrder()">
      <div class="badge legal-badge" v-if="o.payment.length > 0 && o.payment[0].service == 'bank-transfer'">
        ЮРИДИЧЕСКОЕ ЛИЦО
      </div>
      
      <div class="badge transfer-badge" v-if="o.pereezd">
        ПЕРЕМЕЩЕНИЕ
      </div>
    </div>
  </div>

  <transition name="opacity">
      <modalokno 
        :close="() => oneOrderItems = {}" 
        :text="`Cостав заказа`" 
        :button="'понятно'" 
        v-if="viewOknoOrderItems"
       >
        <div class="blockSostavZakaz">
           <orderitemsostav v-for="one of oneOrderItems.items" :key="one._id" :d="one"/>
        </div>
      </modalokno>
    </transition>


  <transition name="slimeright">
    <slotokno 
      :close="() => oneOrder = {}" 
      :text="viewTextName" 
      v-if="viewOknoOrder"
    >
      <component 
        :is="openOrder" 
        :d="oneOrder" 
        @close="oneOrder = {}"
      />
    </slotokno>
  </transition>
</template>

<script setup>
import { orderInfoStatus, channelInfo, goodData, deliveryName } from '@/controlles/general'
import { computed, ref } from 'vue'
import { activity } from '@/controlles/client'
import orderitemsostav from '@/components/order/orderitemsostav.vue'
import { channelRole, skladview } from '@/controlles/auth'
import allorder from '@/components/order/allorder.vue'
import returnorder from '@/components/order/returnorder.vue'
import sborka from '@/components/order/sborka.vue'
import axios from '@/utils/axios'
import { useRoute } from 'vue-router'


const url = `${process.env.VUE_APP_API_BD}`
const props = defineProps(['o', 'options'])
const oneOrder = ref({})
const oneOrderItems = ref({})
const viewTextName = ref('')
const r = useRoute()

const viewPriceAll = computed(() => {
  let price = props.o.items.reduce((x, m) => x += m.price * m.quantity, 0)
  if (props.o.delivery.length > 0) { price = price + props.o.delivery[0].price }
  return price
})

const hasSpecialBadges = computed(() => {
  return (props.o.payment.length > 0 && props.o.payment[0].service == 'bank-transfer') || props.o.pereezd
})

const getStatusClass = (status) => {
  const statusMap = {
    'pending': 'status-pending',
    'processing': 'status-processing',
    'completed': 'status-completed',
    'cancelled': 'status-cancelled',
    'refunded': 'status-refunded'
  }
  return statusMap[status] || 'status-default'
}

const openOrder = computed(() => {
  const o = props.o
  const options = props.options
  
  if (channelRole.value == 'warehouse' && o.warehouse == skladview.value) {
    if (options == 'return') {
      viewTextName.value = `возврат ${o.ordernumber} ${o.crmnumber ? `/ ${o.crmnumber}` : ''}`
      return returnorder
    }
    if (options == 'sborka' || options == 'default') {
      viewTextName.value = `сборка ${o.ordernumber} ${o.crmnumber ? `/ ${o.crmnumber}` : ''}`
      return sborka
    }
  }
  
  if (channelRole.value == 'shop') {
    if (options == 'return') {
      viewTextName.value = `возврат ${o.ordernumber} ${o.crmnumber ? `/ ${o.crmnumber}` : ''}`
      return returnorder
    }
    if (options == 'default' && o.warehouse == skladview.value) {
      viewTextName.value = `заказ ${o.ordernumber} ${o.crmnumber ? `/ ${o.crmnumber}` : ''}`
      return allorder
    }
    if (options == 'sborka' && o.warehouse == skladview.value) {
      viewTextName.value = `сборка ${o.ordernumber} ${o.crmnumber ? `/ ${o.crmnumber}` : ''}`
      return sborka
    }
  }
  
  viewTextName.value = `Закрыть заказ ${o.ordernumber} ${o.crmnumber ? `/ ${o.crmnumber}` : ''}`
  return allorder
})

const getOneOrder = async () => {
  try {
    
    if(r.name == 'order-movements'){
      return await getOneOrderItems()
    }

    if(['club-owner','club-manager'].includes(channelRole.value)){
      return await getOneOrderItems()
    }

    const oneOrderGet = await axios.post(`${url}/bd`, {
      collection: 'order',
      filter: { _id: props.o._id },
      populate: [
        { path: 'contragent', select: ['firstname', 'lastname', 'phone', 'avatar'] },
        {
          path: 'items.productid',
          select: ['images', 'artikul', 'specifications'],
          populate: [{
            path: 'model', select: ['marking']
          }]
        }
      ]
    })
   
    oneOrder.value = oneOrderGet.data[0]
  } catch (e) {
    console.error('Error loading order:', e)
  }
}

const getOneOrderItems = async () => {
  try {
    const oneOrderGet = await axios.post(`${url}/bd`, {
      collection: 'order',
      filter: { _id: props.o._id },
      populate: [
        {
          path: 'items.productid',
          select: ['images', 'artikul', 'specifications']
        }
      ]
    })
    oneOrderItems.value = oneOrderGet.data[0]
  } catch (e) {
    console.error('Error loading order:', e)
  }
}

const viewOknoOrder = computed(() => !!Object.keys(oneOrder.value).length)
const viewOknoOrderItems = computed(() => !!Object.keys(oneOrderItems.value).length)
const payMentsGood = computed(() => {
  let pament = false
  if (props.o.payment.length > 0) {
    let fullP = 0
    for (const one of props.o.payment) {
      if (one.status == 'paid') {
        pament = true
        fullP = fullP + one.price
      }
    }
    if (viewPriceAll.value !== fullP) {
      pament = false
    }
  }
  return pament
})


</script>

<style scoped>
.order-card {
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  border-radius: var(--border-radius-md);
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px var(--shadow-color);
  transition: all var(--transition-fast);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.order-card:hover {
  background: var(--tile-hover-bg);
  border-color: var(--tile-hover-border);
  box-shadow: 0 4px 10px var(--shadow-color);
  transform: translateY(-1px);
}

.order-card:active {
  transform: translateY(0);
}

/* Хедер заказа */
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.order-number {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.number {
  font-size: 15px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.crm-number {
  font-size: 11px;
  font-weight: 300;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  padding: 2px 6px;
  border-radius: var(--border-radius-sm);
}

/* Статус заказа */
.order-status {
  font-size: 11px;
  font-weight: var(--font-weight-medium);
  padding: 4px 8px;
  border-radius: var(--border-radius-xl);
  text-transform: lowercase;
  white-space: nowrap;
}

.status-pending {
  background: #fef3c7;
  color: #92400e;
}

.status-processing {
  background: #dbeafe;
  color: #1e40af;
}

.status-completed {
  background: #dcfce7;
  color: #166534;
}

.status-cancelled {
  background: #fee2e2;
  color: #991b1b;
}

.status-refunded {
  background: #f3e8ff;
  color: #6b21a8;
}

.status-default {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

/* Темная тема для статусов */
html.dark .status-pending {
  background: #78350f;
  color: #fef3c7;
}

html.dark .status-processing {
  background: #1e3a8a;
  color: #dbeafe;
}

html.dark .status-completed {
  background: #14532d;
  color: #dcfce7;
}

html.dark .status-cancelled {
  background: #7f1d1d;
  color: #fee2e2;
}

html.dark .status-refunded {
  background: #4a1d96;
  color: #f3e8ff;
}

/* Информационные строки */
.info-line {
 display: grid;
    gap: 6px;
    padding: 2px 0;
    align-items: center;
    grid-template-columns: auto 1fr;
}

.info-label {
    font-size: 13px;
    color: var(--text-tertiary);
    font-weight: 300;
}

.info-value {
  color: var(--text-primary);
  font-weight: 400;
  font-size: 13px;
  text-align: right;
}

/* Три блока статистики */
.order-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  background: var(--bg-secondary);
  border-radius: var(--border-radius-sm);
  padding: 10px 8px;
  border: 1px solid var(--border-light);
  margin-top: 4px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
}

.stat-label {
  font-size: 10px;
  font-weight: 300;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.stat-value {
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.stat-value.price {
  color: var(--accent-black);
  font-weight: var(--font-weight-semibold);
}

/* Специальный блок для юрлица и перемещения */
.special-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px dashed var(--border-light);
}

.badge {
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  padding: 6px 10px;
  border-radius: var(--border-radius-sm);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  width: 100%;
}

.legal-badge {
  background: #4ade80;
  color: #14532d;
  border: 1px solid #22c55e;
}

.transfer-badge {
  background: #60a5fa;
  color: #1e3a8a;
  border: 1px solid #3b82f6;
}

html.dark .legal-badge {
  background: #14532d;
  color: #4ade80;
  border-color: #16a34a;
}

html.dark .transfer-badge {
  background: #1e3a8a;
  color: #60a5fa;
  border-color: #2563eb;
}

.order-and-full{
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap:2px;
}

.order-and-full svg path,.order-and-full svg rect{
  stroke-width: 1px;
}

.noOp{
  
}
</style>